import { ComposicaoRda } from './composicao-rda.model';

export class RdaAutenticado {

  composicaoRda: ComposicaoRda;
  composicaoRdaResponsavelPreenchimento: ComposicaoRda;
  quantidadeEmpresasAssociadas: number;
  incentivada: boolean;
  contratante: boolean;
  padis: boolean;
  enviouRda: boolean;
  versao: number;

  constructor(init?: Partial<RdaAutenticado>) {
    Object.assign(this, init);
  }

}
